import React from "react";
import Body from "./Body";

const ScolarshipAndFeeWaiver = () => {
  const ScolarshipColumns = [
    {
      header: "Name and ID",
      accessor: "name",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={row.image} alt={row.name} className="avatar" />
          <div>
            <strong>{row.name}</strong>
            <div className="student-id">ID: {row.id}</div>
          </div>
        </div>
      ),
    },
    {
      header: "Class",
      accessor: "class",
      render: (value) => <span style={{ color: "#6ba76b" }}>{value}</span>,
    },
    {
      header: "Amount (INR)",
      accessor: "amount",
      render: (value) => <span className="green-text">₹ {value}</span>,
    },
  ];

  const ScolarShipStudents = [
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/B",
      amount: 2300,
      image: "/images/toufik.jpg",
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/B",
      amount: 2300,
      image: "/images/mustak.jpg",
    },
    {
      name: "Anisur Islam",
      id: "SM0824109",
      class: "5/B",
      amount: 2300,
      image: "/images/anisur.jpg",
    },
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/B",
      amount: 2300,
      image: "/images/toufik.jpg",
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/B",
      amount: 2300,
      image: "/images/mustak.jpg",
    },
    {
      name: "Anisur Islam",
      id: "SM0824109",
      class: "5/B",
      amount: 2300,
      image: "/images/anisur.jpg",
    },
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/B",
      amount: 2300,
      image: "/images/toufik.jpg",
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/B",
      amount: 2300,
      image: "/images/mustak.jpg",
    },
    {
      name: "Anisur Islam",
      id: "SM0824109",
      class: "5/B",
      amount: 2300,
      image: "/images/anisur.jpg",
    },
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/B",
      amount: 2300,
      image: "/images/toufik.jpg",
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/B",
      amount: 2300,
      image: "/images/mustak.jpg",
    },
    {
      name: "Anisur Islam",
      id: "SM0824109",
      class: "5/B",
      amount: 2300,
      image: "/images/anisur.jpg",
    },
  ];
  const FeeWaiverColumns = [
    {
      header: "Name and ID",
      accessor: "name",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={row.image} alt={row.name} className="avatar" />
          <div>
            <strong>{row.name}</strong>
            <div className="student-id">ID: {row.id}</div>
          </div>
        </div>
      ),
    },
    {
      header: "Class",
      accessor: "class",
      render: (value) => <span style={{ color: "#6ba76b" }}>{value}</span>,
    },
    {
      header: "Amount (INR)",
      accessor: "amount",
      render: (value) => <span className="green-text">₹ {value}</span>,
    },
  ];

  const FeeWaiverStudents = [
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/B",
      amount: 2300,
      image: "/images/toufik.jpg",
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/B",
      amount: 2300,
      image: "/images/mustak.jpg",
    },
    {
      name: "Anisur Islam",
      id: "SM0824109",
      class: "5/B",
      amount: 2300,
      image: "/images/anisur.jpg",
    },
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/B",
      amount: 2300,
      image: "/images/toufik.jpg",
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/B",
      amount: 2300,
      image: "/images/mustak.jpg",
    },
    {
      name: "Anisur Islam",
      id: "SM0824109",
      class: "5/B",
      amount: 2300,
      image: "/images/anisur.jpg",
    },
  ];
  const _this = {
    ScolarshipColumns,
    ScolarShipStudents,
    FeeWaiverColumns,
    FeeWaiverStudents,
  };
  return <Body {..._this} />;
};

export default ScolarshipAndFeeWaiver;
